import { BaseContainerModel } from '../base-container.model';
import { bl_wms_picking_list_hdr_RowInterface, bl_wms_picking_list_hdr_RowClass, 
    bl_wms_picking_list_line_RowClass } from '../../dbschema/index';
    
export class WmsPickingListContainer extends BaseContainerModel {
    bl_wms_grn_hdr: bl_wms_picking_list_hdr_RowInterface = new bl_wms_picking_list_hdr_RowClass();
    bl_wms_picking_list_line: bl_wms_picking_list_line_RowClass[] = [];
}
